module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/Icon/social/facebook_colorfull-59824da998e69c3c4fadd956125a7465.svg";